import { useState, useEffect } from "react";
import moment from 'moment';
import Api from "../services/Api";
import {
  Grid, Typography, Autocomplete, TextField, Button, Paper
} from "@mui/material";
import AdapterMoment from "@mui/lab/AdapterMoment"
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TimePicker from '@mui/lab/TimePicker'


//needs stations to disable, acceptable start times

export const NewOptimizationCard = (props) => {
  return (
    <Paper sx={{padding: "1em"}}>
      <NewOptimizationForm {...props}/>
    </Paper>
  )
}

export const NewOptimizationForm = (props) => {
  const {submit} = props;
  const [disabledStations, setDisabledStations] = useState([]);
  const [earliestStart, setEarliestStart] = useState(moment().hour(7).minute(0));
  const [latestStart, setLatestStart] = useState(moment().hour(12).minute(0));
  const [stationList, setStationList] = useState([]);
  const [newOptName, setNewOptName] = useState("");
  const [numUnits, setNumUnits] = useState(4);
  const [numUnitsError, setNumUnitsError] = useState(false);
  const [nameError, setNameError] = useState(false);

  useEffect(() => {
    const fetch = async () =>{
      let stations = await Api.getAllStations();
      if (stations){
        setStationList(stations);
      }
    }
    fetch();
  }, []);

  const callSubmit = async () =>{
    if (newOptName === "" || newOptName.trim() === ""){
      setNameError(true);
      return;
    }
    let newDisabled = disabledStations.map(x => x.name);
    let requestObj = {NumUnits: numUnits, DisabledStations: newDisabled, EarliestStart: earliestStart.hour(), LatestStart: latestStart.hour(), Name: newOptName};
    let result = await submit(requestObj);
    if (result){
      setNewOptName("");
      setDisabledStations([]);
    }
  }

  const validateNumUnits = (e) => {
    let num = Number(e.target.value);
    if (Number.isNaN(num)){
      setNumUnitsError(true);
    }
    else if (num < 1 || num > 8){
      setNumUnitsError(true);
      let toSet = (num === 0) ? null : num;
      setNumUnits(toSet);
    }
    else{
      if (numUnitsError){
        setNumUnitsError(false);
      }
      setNumUnits(num);
    }
  }

  const onNameChange = (e) => {
    let name = e.target.value;
    if (name === "" || name.trim() === ""){
      setNameError(true);
    }else{
      setNameError(false);
    }
    setNewOptName(name);
  }


  
  return (
    <Grid container justifyContent={"center"} spacing={1}>
      <Grid item xs={12}>
        <Typography variant="h5">
          Create New Optimization
        </Typography>
      </Grid>
      <Grid item container xs={6}>
        <Grid item container xs={12}>
        {/* place start/end time picker here */}
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <Grid item xs={6}>
                <TimePicker
                  label="Earliest Start Time"
                  value={earliestStart}
                  onChange={newVal => {
                    setEarliestStart(newVal);
                  }}
                  renderInput={(params) => <TextField {...params}/>}
                  ampm={false}
                  minTime={moment().hour(6).minute(59)}
                  maxTime={moment().hour(12).minute(1)}
                />
            </Grid>
            <Grid item xs={6}>
                <TimePicker
                  label="Latest Start Time"
                  value={latestStart}
                  onChange={newVal => {
                    setLatestStart(newVal);
                  }}
                  renderInput={(params) => <TextField {...params}/>}
                  ampm={false}
                  minTime={moment().hour(6).minute(59)}
                  maxTime={moment().hour(12).minute(1)}
                />
            </Grid>
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12}>
          {/* place station picker here */}
          <Autocomplete
            multiple
            options={stationList}
            getOptionLabel={(opt) => opt.name}
            value={disabledStations}
            onChange={(event, newValue) => {
              setDisabledStations(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="Exclude Stations"
                aria-label="Exclude Stations Combo Box"
              />
            )}
          />
        </Grid>
      </Grid>

      <Grid item container xs={6}>
        <Grid item xs={6}>
          <TextField inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            label="Number of Daily Units"
            value={numUnits}
            onChange={(e) => validateNumUnits(e)}
            error={numUnitsError}
            helperText={(numUnitsError) ? "Must be from 1 to 8" : null}
          />
        </Grid>
        <Grid item xs={6}>
          {/* place name here? */}
          <TextField 
            variant="standard"
            label="Name"
            value={newOptName}
            fullWidth
            onChange={onNameChange}
            error={nameError}
            helperText={(nameError) ? "Cannot be blank" : null}
          />
        </Grid>
        <Grid item xs={12} sx={{textAlign: "center"}}>
          {/* place go button here */}
          <Button disabled={numUnitsError || nameError} variant="contained" sx={{width: "12em"}} onClick={() => callSubmit()}>
            Start
          </Button>
        </Grid>

      </Grid>



    </Grid>
  )


}